const ADDRESS = 'ADDRESS';
const ADDRESS_FETCH_STARTED = ADDRESS + '_FETCH_STARTED';
const ADDRESS_FETCH_COMPLETED = ADDRESS + '_FETCH_COMPLETED';

export {
  ADDRESS_FETCH_COMPLETED, ADDRESS_FETCH_STARTED
};
